module.exports = __webpack_public_path__ + "static/media/british_petroleum_logo.a3798cf5.png";